import {gql} from "apollo-boost";

export const GET_ACADEMICPERIODCONFIGS_CURRENT = gql`
  query getCurrentAcademicPeriodConfig{
    getCurrentAcademicPeriodConfig {
      id applyPeriodCode learnPeriodCode enrollPeriodCode
      applyPeriod{
        id periodCode year semester
      }
      learnPeriod{
        id periodCode year semester
      }
      enrollPeriod{
        id periodCode year semester
      }
    }
  }
`;

export const GET_ACADEMICPERIODCONFIG = gql`
  query getAcademicPeriodConfig($id: ID!) {
    getAcademicPeriodConfig(
      id: $id
    ) {
      id applyPeriodCode learnPeriodCode enrollPeriodCode
      applyPeriod{
        id periodCode year semester
      }
      learnPeriod{
        id periodCode year semester
      }
      enrollPeriod{
        id periodCode year semester
      }
    }
  }
`;


export const GET_ACADEMICPERIODCONFIGS = gql`
  query getAcademicPeriodConfigs {
    getAcademicPeriodConfigs {
      id applyPeriodCode learnPeriodCode enrollPeriodCode
      zoneGroup { id }
      applyPeriod{
        id periodCode year semester
      }
      learnPeriod{
        id periodCode year semester
      }
      enrollPeriod{
        id periodCode year semester
      }
    }
  }
`;

export const ADD_ACADEMICPERIODCONFIG = gql`
  mutation addAcademicPeriodConfig(
    $applyPeriodId: ID!,
    $applyPeriodCode: String!,
    $learnPeriodId: ID!,
    $learnPeriodCode: String!,
    $enrollPeriodId: ID!,
    $enrollPeriodCode: String!
    $zoneGroupId: ID!,
    $zoneGroup: String!
  ) {
    addAcademicPeriodConfig (
      applyPeriodId: $applyPeriodId,
      applyPeriodCode: $applyPeriodCode,
      learnPeriodId: $learnPeriodId,
      learnPeriodCode: $learnPeriodCode,
      enrollPeriodId: $enrollPeriodId,
      enrollPeriodCode: $enrollPeriodCode,
      zoneGroupId: $zoneGroupId,
      zoneGroup: $zoneGroup
    ) {
      id applyPeriodCode learnPeriodCode enrollPeriodCode
      applyPeriod{
        id periodCode year semester
      }
      learnPeriod{
        id periodCode year semester
      }
      enrollPeriod{
        id periodCode year semester
      }
      zoneGroup { id }
    }
  }
`;

export const UPDATE_ACADEMICPERIODCONFIG = gql`
  mutation updateAcademicPeriodConfig(
    $id: ID!,
    $applyPeriodId: ID!,
    $applyPeriodCode: String!,
    $learnPeriodId: ID!,
    $learnPeriodCode: String!,
    $enrollPeriodId: ID!,
    $enrollPeriodCode: String!,
    $zoneGroupId: ID!,
    $zoneGroup: String!
  ) {
    updateAcademicPeriodConfig (
      id: $id,
      applyPeriodId: $applyPeriodId,
      applyPeriodCode: $applyPeriodCode,
      learnPeriodId: $learnPeriodId,
      learnPeriodCode: $learnPeriodCode,
      enrollPeriodId: $enrollPeriodId,
      enrollPeriodCode: $enrollPeriodCode
      zoneGroupId: $zoneGroupId,
      zoneGroup: $zoneGroup
    ) {
      id applyPeriodCode learnPeriodCode enrollPeriodCode
      applyPeriod{
        id periodCode year semester
      }
      learnPeriod{
        id periodCode year semester
      }
      enrollPeriod{
        id periodCode year semester
      }
      zoneGroup { id }
    }
  }
`;

export const DELETE_ACADEMICPERIODCONFIG = gql`
  mutation deleteAcademicPeriodConfig(
    $id: ID!
  ) {
    deleteAcademicPeriodConfig (
      id: $id
    ) {
      id
    }
  }
`;


